import { httpAuthAdmin } from '../plugins/http'

class PaymentTypeService {
  getAll() {
    return httpAuthAdmin().get("/paymenttypes");
  }
}

export default new PaymentTypeService();